var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCause03 = function SvgIconCause03(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 29 29"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#906F2F",
    d: "M15.316 11.815h8.166l-10.5 15.167v-10.5H4.816l10.5-15.167z"
  })));
};
export default SvgIconCause03;